import { Locale, Translation } from 'locale'
import React, { useState } from 'react'
import { createWorkflowAliasesDetailsSelector } from 'selectors/workflowSelectors'
import { useParametricSelector } from 'utils'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { AgGridWrapper } from 'view/components/datagrid'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { TradingEntityAliasesPanelDialog } from './TradingEntityAliasesPanelDialog'
import {
  tradingEntityAliasesPanelColumnDefs,
  TradingEntityAliasesPanelGridColumnId,
  tradingEntityAliasesPanelGridOptions
} from './TradingEntityAliasesPanelGridModel'
import { GroupboxStyled, Header } from './TradingEntityAliasesPanelStyles'

interface TradingEntityAliasesPanelProps extends ModalConsumerProps {
  workflowId: string
  tradingEntityId: string
  readOnly?: boolean
}

const aliasesSelector = createWorkflowAliasesDetailsSelector((_, workflowId: string) => workflowId)

export const TradingEntityAliasesPanel = withModal((props: TradingEntityAliasesPanelProps) => {
  const aliasesDetails = useParametricSelector(aliasesSelector, props.workflowId)

  const [columns] = useState(
    props.readOnly
      ? tradingEntityAliasesPanelColumnDefs.filter(c => c.colId !== TradingEntityAliasesPanelGridColumnId.ACTIONS)
      : tradingEntityAliasesPanelColumnDefs
  )

  const onAddAlias = () => {
    props.showModal(
      <TradingEntityAliasesPanelDialog
        workflowInfo={{ workflowId: props.workflowId, metaId: null, index: null }}
        ownerTradingEntityId={props.tradingEntityId}
      />
    )
  }

  return (
    <GroupboxStyled>
      <Header>
        <label>{Locale.translate(Translation.TC_TRADING_ENTITY_ALIAS)}</label>
        {!props.readOnly && (
          <TextButton type={TextButtonType.Primary} onClick={onAddAlias}>
            {Locale.translate(Translation.TC_ADD_NEW_ALIAS)}
          </TextButton>
        )}
      </Header>

      <AgGridWrapper
        className="datagrid-borderless"
        columnDefs={columns}
        gridOptions={tradingEntityAliasesPanelGridOptions}
        placeholder={NoAliasesMessagePlaceholder}
        rowData={aliasesDetails}
        context={{
          workflowId: props.workflowId,
          tradingEntityId: props.tradingEntityId
        }}
      />
    </GroupboxStyled>
  )
})

function NoAliasesMessagePlaceholder() {
  return <div>{Locale.translate(Translation.TC_NO_ALIASES)}</div>
}
